import React, { createElement } from 'react';
import { TimelineItem, TimelineRegistry } from 'framework/ui/timeline';
import type { Data } from 'framework/types';
import CreateRiskUserNoteForm from './createupdate/CreateRiskUserNoteForm';
import RiskNoteTimelineUpdateForm from './createupdate/RiskNoteTimelineUpdateForm';
import RiskNoteTimelineRecordLayout from './RiskNoteTimelineRecordLayout';
import ProjectSystemNoteTimelineRecordLayout from '../../timeline/ProjectSystemNoteTimelineRecordLayout';

export const RISK_NOTE_SOURCE = 'riskNote';
export const RISK_SYSTEM_NOTE_SOURCE = 'riskSystemNote';

interface ProjectNoteRegistryOptions {
  refetch?: () => Promise<void>;
}

const AddRiskNoteForm = (props: any) =>
  createElement(CreateRiskUserNoteForm, {
    ...props,
    onCancel: props.onCancel ?? (() => {}),
    label: 'Note text (not available for customer report)',
  });

const useRiskNoteTimelineRegistry = (options: ProjectNoteRegistryOptions = {}): TimelineRegistry => {
  const { refetch } = options;
  return {
    name: 'Note',
    AddForm: AddRiskNoteForm as TimelineRegistry['AddForm'],
    UpdateForm: RiskNoteTimelineUpdateForm as unknown as React.ReactElement,
    RecordLayout: RiskNoteTimelineRecordLayout as unknown as React.ReactElement,
    isApplicable: (item: TimelineItem) => !!(item as Record<string, unknown>)?.[RISK_NOTE_SOURCE],
    source: RISK_NOTE_SOURCE,
    urlPostfix: 'notes',
    additionalAfterAddSubmit: refetch
      ? (_data: TimelineItem, _parentContext?: Data, _reloadData?: () => void) => {
          refetch();
        }
      : undefined,
  };
};

export const useRiskSystemNoteTimelineRegistry = (): TimelineRegistry => ({
  name: 'SystemNote',
  AddForm: (() => null) as TimelineRegistry['AddForm'],
  UpdateForm: (() => null) as unknown as React.ReactElement,
  RecordLayout: ProjectSystemNoteTimelineRecordLayout as unknown as React.ReactElement,
  isApplicable: (item: TimelineItem) => !!(item as Record<string, unknown>)?.[RISK_SYSTEM_NOTE_SOURCE],
  source: RISK_SYSTEM_NOTE_SOURCE,
  urlPostfix: 'system-notes',
  withoutAddFunctionality: true,
});

export default useRiskNoteTimelineRegistry;
